module.exports = __webpack_public_path__ + "assets/media/quote-mark.c449de8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Deal/SalesRepWelcome/quote-mark.svg
// module id = 2844
// module chunks = 0